import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IBakimOzet_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IBakimOzet_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  BakimGetir: any[];
  BakimGetir_dummy: any[];
  isComp802912Visible: "visible" | "hidden";
  isComp419022Visible: "visible" | "hidden";
}

export class BakimOzet_ScreenBase extends React.PureComponent<
  IBakimOzet_ScreenProps,
  any
> {
  ml = [
    {
      Id: "bd00ad4a-ed44-61e3-4813-27fcfc1bccc8",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f0b40ca-a5d3-4b72-bc52-230e83587430",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "e755e07a-d178-482d-808a-862f527f61bd",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 683548, PropertyName: "value", Value: "Bakım Özeti" },
        { Id: 165651, PropertyName: "value", Value: "Bakım No:" },
        { Id: 802912, PropertyName: "value", Value: "Kayıtlı" },
        { Id: 419022, PropertyName: "value", Value: "İptal" },
        { Id: 933868, PropertyName: "value", Value: "BAŞLANGIÇ ZAMANI" },
        { Id: 158447, PropertyName: "value", Value: "BİTİŞ ZAMANI" },
        { Id: 573705, PropertyName: "value", Value: "BAKIM NEDENLERİ" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      BakimGetir: [],
      isComp802912Visible: "hidden",
      isComp419022Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("bakimozet", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.BakimOzetPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("bakimozet", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("bakimozet", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.BakimOzetPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  BakimOzetPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BakimOzet/BakimOzetPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BakimGetir = result?.data.bakimGetir;
    formVars.bakimozet_792401_value = ReactSystemFunctions.toString(
      this,
      stateVars.BakimGetir !== undefined
        ? stateVars.BakimGetir?.length > 0
          ? stateVars.BakimGetir[0].bakimNo
          : null
        : this.state.BakimGetir?.length > 0
        ? this.state.BakimGetir[0].bakimNo
        : null
    );
    formVars.bakimozet_910775_value = ReactSystemFunctions.value(
      this,
      stateVars.BakimGetir !== undefined
        ? stateVars.BakimGetir?.length > 0
          ? stateVars.BakimGetir[0].baslangicZamani
          : null
        : this.state.BakimGetir?.length > 0
        ? this.state.BakimGetir[0].baslangicZamani
        : null
    );
    formVars.bakimozet_671253_value = ReactSystemFunctions.value(
      this,
      stateVars.BakimGetir !== undefined
        ? stateVars.BakimGetir?.length > 0
          ? stateVars.BakimGetir[0].bitisZamani
          : null
        : this.state.BakimGetir?.length > 0
        ? this.state.BakimGetir[0].bitisZamani
        : null
    );
    formVars.bakimozet_931178_value = ReactSystemFunctions.toString(
      this,
      stateVars.BakimGetir !== undefined
        ? stateVars.BakimGetir?.length > 0
          ? stateVars.BakimGetir[0].bakimNedenleri
          : null
        : this.state.BakimGetir?.length > 0
        ? this.state.BakimGetir[0].bakimNedenleri
        : null
    );
    stateVars.isComp802912Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BakimGetir !== undefined
            ? stateVars.BakimGetir?.length > 0
              ? stateVars.BakimGetir[0].isIptal
              : null
            : this.state.BakimGetir?.length > 0
            ? this.state.BakimGetir[0].isIptal
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp419022Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BakimGetir !== undefined
            ? stateVars.BakimGetir?.length > 0
              ? stateVars.BakimGetir[0].isIptal
              : null
            : this.state.BakimGetir?.length > 0
            ? this.state.BakimGetir[0].isIptal
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BakimOzetPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BakimOzetPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.bakimozet_792401_value = ReactSystemFunctions.toString(
      this,
      stateVars.BakimGetir !== undefined
        ? stateVars.BakimGetir?.length > 0
          ? stateVars.BakimGetir[0].bakimNo
          : null
        : this.state.BakimGetir?.length > 0
        ? this.state.BakimGetir[0].bakimNo
        : null
    );

    stateVars.isComp802912Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BakimGetir !== undefined
            ? stateVars.BakimGetir?.length > 0
              ? stateVars.BakimGetir[0].isIptal
              : null
            : this.state.BakimGetir?.length > 0
            ? this.state.BakimGetir[0].isIptal
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp419022Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BakimGetir !== undefined
            ? stateVars.BakimGetir?.length > 0
              ? stateVars.BakimGetir[0].isIptal
              : null
            : this.state.BakimGetir?.length > 0
            ? this.state.BakimGetir[0].isIptal
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.bakimozet_910775_value = ReactSystemFunctions.value(
      this,
      stateVars.BakimGetir !== undefined
        ? stateVars.BakimGetir?.length > 0
          ? stateVars.BakimGetir[0].baslangicZamani
          : null
        : this.state.BakimGetir?.length > 0
        ? this.state.BakimGetir[0].baslangicZamani
        : null
    );

    formVars.bakimozet_671253_value = ReactSystemFunctions.value(
      this,
      stateVars.BakimGetir !== undefined
        ? stateVars.BakimGetir?.length > 0
          ? stateVars.BakimGetir[0].bitisZamani
          : null
        : this.state.BakimGetir?.length > 0
        ? this.state.BakimGetir[0].bitisZamani
        : null
    );

    formVars.bakimozet_931178_value = ReactSystemFunctions.toString(
      this,
      stateVars.BakimGetir !== undefined
        ? stateVars.BakimGetir?.length > 0
          ? stateVars.BakimGetir[0].bakimNedenleri
          : null
        : this.state.BakimGetir?.length > 0
        ? this.state.BakimGetir[0].bakimNedenleri
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  BakimOzetComponent_782078_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.BakimOzetPageInit();
    }
  }
}
